import { Injectable } from '@angular/core';
//
import { estruturasRoute } from "../../shared/data.service";
import { divisoesRoute } from "./data.service";
import { AuthService } from "../../../shared/services/auth.service";
import { newRoute, editRoute } from "../../../shared/services/data.service";

@Injectable()
export class DivisaoNavigationService {
  fatherRouter: string = estruturasRoute;
  moduleRouter: string = divisoesRoute;

  constructor(
    private _authService: AuthService
  ) { }

  goToList() {
    var router: string = this.fatherRouter + '/' + this.moduleRouter;
    this._authService.navigateTo(router);
  }
  
  goToNew() {
    var router: string = this.fatherRouter + '/' + this.moduleRouter + '/' + newRoute;
    this._authService.navigateTo(router);
  }
  
  goToEdit(objectId: number) {
    var router: string = this.fatherRouter + '/' + this.moduleRouter + '/' + editRoute;
    this._authService.navigateTo(router, objectId);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/divisoes/shared/divisao-navigation.service.ts
 **/